<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码" class="itemcode">
              <a-input-group compact>
                <a-input v-model="queryParams.itemCode" />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料状态">
              <global-select
                :value.sync="queryParams.itemStatusCode"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findItemStatusList"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料类型">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                option-filter-prop="children"
                :value.sync="queryParams.itemType"
                selectType="selectMultiple"
                :selectData="itemTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划方法">
              <!-- <a-select v-model="queryParams.planningMethod">
                <a-select-option v-for="item in planningMethodList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select> -->
              <global-select
                :value.sync="queryParams.planningCode"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findPlanningCodeList"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="规格描述">
              <a-input v-model="queryParams.description" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="集采类型">
              <!-- <a-select v-model="queryParams.centralizedPurchasingType">
                <a-select-option v-for="item in centralizedPurchasingTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select> -->
              <global-select
                :value.sync="queryParams.centralizedPurchasingType"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findPurchasingTypeList"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="采购员">
              <a-select v-model="queryParams.buyerName">
                <a-select-option v-for="item in buyerNameList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="备料分类">
              <!-- <a-select v-model="queryParams.itemPreparationClass">
                <a-select-option v-for="item in itemPreparationClassList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select> -->
              <global-select
                :value.sync="queryParams.deliveryType"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findDeliveryTypeList"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <!-- 暂时隐藏 -->
          <!-- <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="类别集">
              <a-select v-model="queryParams.categorySetId">
                <a-select-option v-for="item in categorySetIdList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="类别">
              <a-select v-model="queryParams.categoryCodeId">
                <a-select-option v-for="item in categoryCodeIdList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <!-- 暂时隐藏 -->
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="可制造">
              <a-select v-model="queryParams.buildInWipFlag">
                <a-select-option v-for="item in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="可采购">
              <a-select v-model="queryParams.purchasingEnabledFlag">
                <a-select-option v-for="item in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemOrganizationItemNewExport" ref="download" />
      <a-button @click="handleExport" v-hasPermi="['mdm:mdmItemOrganizationItem:export']">导出</a-button>
      <!-- <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['mdm:itemAttribute:import']">导入</a-button>
      <a-button @click="importTemplate">下载模板</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-tabs default-active-key="主要属性" type="card" @change="tabOnchange">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.key"></a-tab-pane>
        </a-tabs>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <!-- 主要属性 -->
          <template slot="organizationCode" slot-scope="text">
            <span>{{ text.record.mdmItemOrganizaitonItemVO.organizationCode }}</span>
          </template>
          <template slot="itemStatusCode" slot-scope="text">
            <span>{{ text.record.mdmItemOrganizaitonItemVO && text.record.mdmItemOrganizaitonItemVO.itemStatusCode }}</span>
          </template>
          <template slot="bomEnabledFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.bomEnabledFlag === 'Y'" @change="statusOnChange(text.record, 'bomEnabledFlag')" />
          </template>

          <!-- 物理属性 -->
          <template slot="volumeUom" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.volumeUom }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.volumeUom" size="small" />
          </template>
          <template slot="unitVolume" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.unitVolume }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.unitVolume" size="small" />
          </template>

          <!-- 库存属性 -->
          <template slot="stockEnabledFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.stockEnabledFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'stockEnabledFlag')" />
          </template>
          <template slot="lotControlCode" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.lotControlCode === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'lotControlCode')" />
          </template>
          <template slot="shelfLifeDays" slot-scope="text">
            <span>{{ text.record.mdmItemOrganizaitonItemVO.shelfLifeDays }}</span>
          </template>
          <template slot="invTransactionsEnabledFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.invTransactionsEnabledFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'invTransactionsEnabledFlag')" />
          </template>
          <template slot="reservableType" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.reservableType === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'reservableType')" />
          </template>

          <!-- 采购属性 -->
          <template slot="purchasingEnabledFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.purchasingEnabledFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'purchasingEnabledFlag')" />
          </template>
          <template slot="purchasingUom" slot-scope="text">
            <span>{{ text.record.mdmItemOrganizaitonItemVO.purchasingUom }}</span>
          </template>
          <template slot="centralizedPurchasingTypeDesc" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.centralizedPurchasingTypeDesc }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.centralizedPurchasingTypeDesc" size="small">
              <a-select-option v-for="item in centralizedPurchasingTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>

          <!-- 计划属性 -->
          <template slot="planningCodeDesc" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.planningCodeDesc }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.planningCodeDesc" size="small">
              <a-select-option v-for="item in planningMethodList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="planningMakeBuyCodeDesc" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.planningMakeBuyCodeDesc }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.planningMakeBuyCodeDesc" size="small" />
          </template>
          <template slot="maximumOrderQuantity" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.maximumOrderQuantity }}</span>
            <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.maximumOrderQuantity" :min="0" size="small" />
          </template>
          <template slot="minimumOrderQuantity" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.minimumOrderQuantity }}</span>
            <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.minimumOrderQuantity" :min="0" size="small" />
          </template>
          <template slot="roundingControlType" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.roundingControlType === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'roundingControlType')" />
          </template>
          <template slot="criticalComponentFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.criticalComponentFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'criticalComponentFlag')" />
          </template>
          <template slot="deliveryTypeDesc" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.deliveryTypeDesc }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.deliveryTypeDesc" size="small">
              <a-select-option v-for="item in itemPreparationClassList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="fixedLotMultiplier" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.fixedLotMultiplier }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.fixedLotMultiplier" size="small" />
          </template>
          <template slot="acceptableEarlyDays" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.acceptableEarlyDays }}</span>
            <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.acceptableEarlyDays" :min="0" size="small" />
          </template>
          <template slot="fixedDaysSupply" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.fixedDaysSupply }}</span>
            <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.fixedDaysSupply" :min="0" size="small" />
          </template>
          <template slot="shrinkageRate" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.shrinkageRate }}</span>
            <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.shrinkageRate" :min="0" size="small" />
          </template>

          <!-- 提前期属性 -->
          <template slot="preprocessingLeadTime" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.preprocessingLeadTime }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.preprocessingLeadTime" size="small" />
          </template>
          <template slot="purchasingLeadTime" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.purchasingLeadTime }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.purchasingLeadTime" size="small" />
          </template>
          <template slot="postprocessingLeadTime" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.postprocessingLeadTime }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.postprocessingLeadTime" size="small" />
          </template>
          <template slot="fixedLeadTime" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.fixedLeadTime }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.fixedLeadTime" size="small" />
          </template>
          <template slot="variableLeadTime" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.variableLeadTime }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.variableLeadTime" size="small" />
          </template>
          <template slot="safetyStockLeadTime" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.safetyStockLeadTime }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.safetyStockLeadTime" size="small" />
          </template>

          <!-- 生产属性 -->
          <template slot="buildInWipFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemOrganizaitonItemVO.buildInWipFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemOrganizaitonItemVO', 'buildInWipFlag')" />
          </template>
          <template slot="wipSupplySubinventory" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.wipSupplySubinventory }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.wipSupplySubinventory" size="small" />
          </template>
          <template slot="wipSupplyLocator" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.wipSupplyLocator }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.wipSupplyLocator" size="small" />
          </template>
          <template slot="wipSupplyTypeDesc" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemOrganizaitonItemVO.wipSupplyTypeDesc }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemOrganizaitonItemVO.wipSupplyTypeDesc" size="small" />
          </template>

          <!-- 成品属性 -->
          <template slot="isStopFlag" slot-scope="text">
            <!-- <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.isStopFlag }}</span> -->
            <a-switch :disabled="true" :checked="text.record.mdmItemProductAttributeVO.isStopFlag === 'Y'" />

          </template>
          <template slot="earliestShelfTime" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.earliestShelfTime }}</span>
          </template>
          <template slot="stopProduceDate" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.stopProduceDate }}</span>
          </template>
          <template slot="projectTeam" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.projectTeam }}</span>
          </template>
          <template slot="foldNumber" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.foldNumber }}</span>
          </template>
          <template slot="mainModel" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.mainModel }}</span>
          </template>
          <template slot="developType" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.developType }}</span>
          </template>
          <template slot="orderType" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.orderType }}</span>
          </template>
          <template slot="productUpgradeProperty" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.productUpgradeProperty }}</span>
          </template>
          <template slot="productCategory" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.productCategory }}</span>
          </template>
          <template slot="narrowCategory" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.narrowCategory }}</span>
          </template>
          <template slot="broadCategory" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.broadCategory }}</span>
          </template>
          <template slot="firstlyStyle" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.firstlyStyle }}</span>
          </template>
          <template slot="secondlyStyle" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.secondlyStyle }}</span>
          </template>
          <template slot="material" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.material }}</span>
          </template>
          <template slot="salesCategory" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.salesCategory }}</span>
          </template>
          <template slot="salesProfitCategory" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.salesProfitCategory }}</span>
          </template>
          <template slot="specializedSupplyDesc" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.specializedSupplyDesc }}</span>
          </template>
          <template slot="softGoodLabelDesc" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.softGoodLabelDesc }}</span>
          </template>
          <template slot="isRetailFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.isRetailFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemProductAttributeVO', 'isRetailFlag')" />
          </template>
          <template slot="isExpressFlag" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.isExpressFlag === 'Y'" @change="statusNewOnChange(text.record, 'mdmItemProductAttributeVO', 'isExpressFlag')" />
          </template>
          <template slot="productBroadCategory" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.productBroadCategory }}</span>
          </template>
          <template slot="fgSupplyTypeDesc" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.fgSupplyTypeDesc }}</span>
          </template>
          <template slot="scpSinvClassifyDesc" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.scpSinvClassifyDesc }}</span>
          </template>
          <template slot="color" slot-scope="text">
            <span>{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.color }}</span>
          </template>
          <template slot="productGroup" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.productGroup }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemProductAttributeVO.productGroup" size="small" />
          </template>
          <template slot="techniqueStructure" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mdmItemProductAttributeVO && text.record.mdmItemProductAttributeVO.techniqueStructure }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.mdmItemProductAttributeVO.techniqueStructure" size="small" />
          </template>
          <!-- 操作 -->
          <!-- <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['mdm:mdmUomClasses:edit']">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span> -->
        </ls-api-table>
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiMdmItemOrganizationItemUpdate, apiMdmItemOrganizationItemList, apiItemCategorySetPullDownList, apiItemCategoryCodePullDownList, apiMdmItemOrganizationItemNewExport } from '@/api/mdm/matter/material-attributes'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'MaterialAttributes',
  components: { DownloadModal },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
       apiMdmItemOrganizationItemNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiMdmItemOrganizationItemList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/itemAttribute/import'
      },
      pageParams: {
        automatic: false,
        pageUrl: '/mdm/mdmItemOrganizationItem/list',
        tableLoading: false
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        itemCodeFrom: undefined,
        itemCodeTo: undefined,
        itemStatusCode: undefined,
        itemType: undefined,
        planningCode: undefined,
        description: undefined,
        centralizedPurchasingType: undefined,
        buyerName: undefined,
        deliveryType: undefined,
        categorySetId: undefined,
        categoryCodeId: undefined,
        buildInWipFlag: undefined,
        purchasingEnabledFlag: undefined
      },
      // 快码表格数据
      typeList: [],
      // 表格字段-主要属性
      columns: [],
      columns1: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 150,
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '主要单位',
          dataIndex: 'primaryUom',
          align: 'center'
        },
        {
          title: '物料类型',
          dataIndex: 'itemType',
          align: 'center'
        },
        {
          title: '物料状态',
          dataIndex: 'itemStatusCode',
          scopedSlots: { customRender: 'itemStatusCode' },
          align: 'center'
        },
        {
          title: '允许BOM',
          dataIndex: 'bomEnabledFlag',
          scopedSlots: { customRender: 'bomEnabledFlag' },
          align: 'center'
        }
      ],
      // 表格字段-物理属性
      columns3: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 120,
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '重量单位',
          dataIndex: 'weightUom',
          width: 100,
          align: 'center'
        },
        {
          title: '毛重',
          dataIndex: 'grossWeight',
          width: 100,
          align: 'center'
        },
        {
          title: '净重',
          dataIndex: 'netWeight',
          width: 100,
          align: 'center'
        },
        {
          title: '体积单位',
          dataIndex: 'volumeUom',
          scopedSlots: { customRender: 'volumeUom' },
          width: 150,
          align: 'center'
        },
        {
          title: '单位体积',
          dataIndex: 'unitVolume',
          scopedSlots: { customRender: 'unitVolume' },
          width: 150,
          align: 'center'
        },
        {
          title: '长度单位',
          dataIndex: 'lengthUom',
          width: 100,
          align: 'center'
        },
        {
          title: '长',
          dataIndex: 'length',
          width: 100,
          align: 'center'
        },
        {
          title: '宽',
          dataIndex: 'width',
          width: 100,
          align: 'center'
        },
        {
          title: '高',
          dataIndex: 'height',
          width: 100,
          align: 'center'
        }
        //  ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格字段-库存属性
      columns4: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '允许库存',
          dataIndex: 'stockEnabledFlag',
          scopedSlots: { customRender: 'stockEnabledFlag' },
          width: 150,
          align: 'center'
        },
        {
          title: '批次控制',
          dataIndex: 'lotControlCode',
          scopedSlots: { customRender: 'lotControlCode' },
          width: 150,
          align: 'center'
        },
        {
          title: '存储期限',
          dataIndex: 'shelfLifeDays',
          scopedSlots: { customRender: 'shelfLifeDays' },
          width: 150,
          align: 'center'
        },
        {
          title: '可处理',
          dataIndex: 'invTransactionsEnabledFlag',
          scopedSlots: { customRender: 'invTransactionsEnabledFlag' },
          width: 150,
          align: 'center'
        },
        {
          title: '可保留',
          dataIndex: 'reservableType',
          scopedSlots: { customRender: 'reservableType' },
          width: 150,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格字段-采购属性
      columns5: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '可采购',
          dataIndex: 'purchasingEnabledFlag',
          scopedSlots: { customRender: 'purchasingEnabledFlag' },
          width: 150,
          align: 'center'
        },
        {
          title: '采购单位',
          dataIndex: 'purchasingUom',
          scopedSlots: { customRender: 'purchasingUom' },
          align: 'center'
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingTypeDesc',
          scopedSlots: { customRender: 'centralizedPurchasingTypeDesc' },
          width: 150,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格字段-计划属性
      columns6: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 120,
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '计划方法',
          dataIndex: 'planningCodeDesc',
          scopedSlots: { customRender: 'planningCodeDesc' },
          width: 150,
          align: 'center'
        },
        {
          title: '制造或采购',
          dataIndex: 'planningMakeBuyCodeDesc',
          scopedSlots: { customRender: 'planningMakeBuyCodeDesc' },
          width: 150,
          align: 'center'
        },
        {
          title: '最大订单量',
          dataIndex: 'maximumOrderQuantity',
          scopedSlots: { customRender: 'maximumOrderQuantity' },
          width: 150,
          align: 'center'
        },
        {
          title: '最小起订量',
          dataIndex: 'minimumOrderQuantity',
          scopedSlots: { customRender: 'minimumOrderQuantity' },
          width: 150,
          align: 'center'
        },
        {
          title: '舍入订单数量',
          dataIndex: 'roundingControlType',
          scopedSlots: { customRender: 'roundingControlType' },
          width: 150,
          align: 'center'
        },
        {
          title: '重要组件',
          dataIndex: 'criticalComponentFlag',
          scopedSlots: { customRender: 'criticalComponentFlag' },
          width: 150,
          align: 'center'
        },
        {
          title: '备料分类',
          dataIndex: 'deliveryTypeDesc',
          scopedSlots: { customRender: 'deliveryTypeDesc' },
          width: 150,
          align: 'center'
        },
        {
          title: '最小包装',
          dataIndex: 'fixedLotMultiplier',
          scopedSlots: { customRender: 'fixedLotMultiplier' },
          width: 150,
          align: 'center'
        },
        {
          title: '容许提前天数',
          dataIndex: 'acceptableEarlyDays',
          scopedSlots: { customRender: 'acceptableEarlyDays' },
          width: 150,
          align: 'center'
        },
        {
          title: '订单合批天数',
          dataIndex: 'fixedDaysSupply',
          scopedSlots: { customRender: 'fixedDaysSupply' },
          width: 150,
          align: 'center'
        },
        {
          title: '损耗率',
          dataIndex: 'shrinkageRate',
          scopedSlots: { customRender: 'shrinkageRate' },
          width: 150,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格字段-提前期属性
      columns7: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 120,
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '预处理提前期',
          dataIndex: 'preprocessingLeadTime',
          scopedSlots: { customRender: 'preprocessingLeadTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '采购提前期',
          dataIndex: 'purchasingLeadTime',
          scopedSlots: { customRender: 'purchasingLeadTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '后处理提前期',
          dataIndex: 'postprocessingLeadTime',
          scopedSlots: { customRender: 'postprocessingLeadTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '固定提前期间',
          dataIndex: 'fixedLeadTime',
          scopedSlots: { customRender: 'fixedLeadTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '可变提前期',
          dataIndex: 'variableLeadTime',
          scopedSlots: { customRender: 'variableLeadTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '备库提前期',
          dataIndex: 'safetyStockLeadTime',
          scopedSlots: { customRender: 'safetyStockLeadTime' },
          width: 150,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格字段-生产属性
      columns8: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          align: 'center',
          width: 150,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '可制造',
          dataIndex: 'buildInWipFlag',
          scopedSlots: { customRender: 'buildInWipFlag' },
          width: 150,
          align: 'center'
        },
        {
          title: '供应子库',
          dataIndex: 'wipSupplySubinventory',
          scopedSlots: { customRender: 'wipSupplySubinventory' },
          width: 150,
          align: 'center'
        },
        {
          title: '供应货位',
          dataIndex: 'wipSupplyLocator',
          scopedSlots: { customRender: 'wipSupplyLocator' },
          width: 150,
          align: 'center'
        },
        {
          title: 'WIP供应类型',
          dataIndex: 'wipSupplyTypeDesc',
          scopedSlots: { customRender: 'wipSupplyTypeDesc' },
          width: 150,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格字段-成品属性
      columns9: [
        {
          title: '组织编码',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 120,
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          width: 120,
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '是否停产',
          dataIndex: 'mdmItemProductAttributeVO.isStopFlag',
          scopedSlots: { customRender: 'isStopFlag' },
          width: 100,
          align: 'center'
        },
        {
          title: '最早上架日期',
          dataIndex: 'earliestShelfTime',
          scopedSlots: { customRender: 'earliestShelfTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '停产日期',
          dataIndex: 'stopProduceDate',
          scopedSlots: { customRender: 'stopProduceDate' },
          width: 150,
          align: 'center'
        },
        {
          title: '项目组',
          dataIndex: 'projectTeam',
          scopedSlots: { customRender: 'projectTeam' },
          width: 100,
          align: 'center'
        },
        {
          title: '系列/主型号',
          dataIndex: 'foldNumber',
          scopedSlots: { customRender: 'foldNumber' },
          width: 150,
          align: 'center'
        },
        {
          title: '主型号',
          dataIndex: 'mainModel',
          scopedSlots: { customRender: 'mainModel' },
          width: 100,
          align: 'center'
        },
        {
          title: '研发分类',
          dataIndex: 'developType',
          scopedSlots: { customRender: 'developType' },
          width: 100,
          align: 'center'
        },
        {
          title: '下单类别',
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' },
          width: 100,
          align: 'center'
        },
        {
          title: '单品升级性质',
          dataIndex: 'productUpgradeProperty',
          scopedSlots: { customRender: 'productUpgradeProperty' },
          width: 150,
          align: 'center'
        },
        {
          title: '商品类别',
          dataIndex: 'productCategory',
          scopedSlots: { customRender: 'productCategory' },
          width: 100,
          align: 'center'
        },
        {
          title: '小类',
          dataIndex: 'narrowCategory',
          scopedSlots: { customRender: 'narrowCategory' },
          width: 100,
          align: 'center'
        },
        {
          title: '大类',
          dataIndex: 'broadCategory',
          scopedSlots: { customRender: 'broadCategory' },
          width: 100,
          align: 'center'
        },
        {
          title: '一级风格',
          dataIndex: 'firstlyStyle',
          scopedSlots: { customRender: 'firstlyStyle' },
          width: 100,
          align: 'center'
        },
        {
          title: '二级风格',
          dataIndex: 'secondlyStyle',
          scopedSlots: { customRender: 'secondlyStyle' },
          width: 100,
          align: 'center'
        },
        {
          title: '材质',
          dataIndex: 'material',
          scopedSlots: { customRender: 'material' },
          width: 100,
          align: 'center'
        },
        {
          title: '销售类目',
          dataIndex: 'salesCategory',
          scopedSlots: { customRender: 'salesCategory' },
          width: 100,
          align: 'center'
        },
        {
          title: '销售利润分类',
          dataIndex: 'salesProfitCategory',
          scopedSlots: { customRender: 'salesProfitCategory' },
          width: 150,
          align: 'center'
        },
        {
          title: '渠道专供',
          dataIndex: 'specializedSupplyDesc',
          scopedSlots: { customRender: 'specializedSupplyDesc' },
          width: 100,
          align: 'center'
        },
        {
          title: '软货标签',
          dataIndex: 'softGoodLabelDesc',
          scopedSlots: { customRender: 'softGoodLabelDesc' },
          width: 100,
          align: 'center'
        },
        {
          title: '是否一件代发',
          dataIndex: 'isExpressFlag',
          scopedSlots: { customRender: 'isRetailFlag' },
          width: 150,
          align: 'center'
        },
        {
          title: '快递方式',
          dataIndex: 'mdmItemProductAttributeVO.isExpressFlag',
          // scopedSlots: { customRender: 'isExpressFlag' },
          width: 100,
          align: 'center'
        },
        {
          title: '工艺大类',
          dataIndex: 'productBroadCategory',
          scopedSlots: { customRender: 'productBroadCategory' },
          width: 100,
          align: 'center'
        },
        // {
        //   title: '供应类型',
        //   dataIndex: 'fgSupplyTypeDesc',
        //   scopedSlots: { customRender: 'fgSupplyTypeDesc' },
        //   width: 100,
        //   align: 'center'
        // },
        {
          title: '安全库存类别',
          dataIndex: 'scpSinvClassifyDesc',
          scopedSlots: { customRender: 'scpSinvClassifyDesc' },
          width: 140,
          align: 'center'
        },
        {
          title: '颜色',
          dataIndex: 'color',
          scopedSlots: { customRender: 'color' },
          width: 100,
          align: 'center'
        },
        {
          title: '产品族',
          dataIndex: 'productGroup',
          scopedSlots: { customRender: 'productGroup' },
          width: 150,
          align: 'center'
        },
        {
          title: '工艺分层',
          dataIndex: 'techniqueStructure',
          scopedSlots: { customRender: 'techniqueStructure' },
          width: 150,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   fixed: 'right'
        // }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      // 页签
      tabList: [
        { key: "主要属性" },
        { key: "物理属性" },
        { key: "库存属性" },
        { key: "采购属性" },
        { key: "计划属性" },
        { key: "提前期属性" },
        { key: "生产属性" },
        { key: "成品属性" }
      ],
      scrollWidth: 800,
      // 可制造、可采购
      yesOrNo: [
        {
          key: "Y",
          value: "是"
        },
        {
          key: "N",
          value: "否"
        }
      ],
      itemTypeList: [], // 物料类型
      planningMethodList: [], // 计划方法
      centralizedPurchasingTypeList: [], // 集采类型
      // buyerNameList: [],
      itemPreparationClassList: [], // 备料分类
      categorySetIdList: [], // 类别集
      categoryCodeIdList: [] // 类别
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.columns = JSON.parse(JSON.stringify(this.columns1))
    this.getLookupList('MDM_ITEM_TYPE', 'itemTypeList')
    this.getLookupList('PLANNING_METHOD', 'planningMethodList')
    // this.getLookupList('PO_CENTRALIZED_PURCHASING_TYPE', 'centralizedPurchasingTypeList')
    this.getLookupList('MDM_CENTRALIZED_PURCHASING_TYPE', 'centralizedPurchasingTypeList')
    this.getLookupList('SCP_ITEM_PREPARATION_CLASS', 'itemPreparationClassList')
    // this.getPullDownList()
    // this.getPullDownCodeList()
  },
  mounted () {
    // this.onSearch()
  },
  methods: {
    onSearch () {
      this.isEdit = false
      this.queryParams.organizationCode = this.organizationCodeOrigin
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    statusNewOnChange (record, val, val2) {
      record[val][val2] = record[val][val2] === 'Y' ? 'N' : 'Y'
    },
    statusOnChange (record, val) {
      record[val] = record[val] === 'Y' ? 'N' : 'Y'
    },
    // 页签切换
    tabOnchange (val) {
      this.handleCancel()
      if (val === "主要属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
        this.scrollWidth = 800
      }
      if (val === "物理属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns3))
        this.scrollWidth = 800
      }
      if (val === "库存属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns4))
        this.scrollWidth = 800
      }
      if (val === "采购属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns5))
        this.scrollWidth = 800
      }
      if (val === "计划属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns6))
        this.scrollWidth = 1500
      }
      if (val === "提前期属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns7))
        this.scrollWidth = 800
      }
      if (val === "生产属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns8))
        this.scrollWidth = 800
      }
      if (val === "成品属性") {
        this.columns = JSON.parse(JSON.stringify(this.columns9))
        this.scrollWidth = 3800
      }
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.columns = JSON.parse(JSON.stringify(this.columns))

      this.originTypeList = JSON.parse(JSON.stringify(this.typeList))
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      apiMdmItemOrganizationItemUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      if (this.isEdit) {
        this.typeList = JSON.parse(JSON.stringify(this.originTypeList))
        this.isEdit = false
      }
    },
    /** 查询列表 */
    getList (data) {
      data.forEach(element => {
        if (!element.mdmItemProductAttributeVO) {
          element.mdmItemProductAttributeVO = {
            productGroup: "",
            techniqueStructure: "",
            isRetailFlag: "",
            isExpressFlag: ""
          }
        }
      });
      this.typeList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    // 物料范围-开始
    staItemCodeOnChange (val) {
      this.queryParams.itemCodeFrom = val
      if (!this.queryParams.itemCodeTo) {
        this.queryParams.itemCodeTo = val
      }
    },
    // 物料范围-结束
    endItemCodeOnChange (val) {
      this.queryParams.itemCodeTo = val
      if (!this.queryParams.itemCodeFrom) {
        this.queryParams.itemCodeFrom = val
      }
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        itemCodeFrom: undefined,
        itemCodeTo: undefined,
        itemStatusCode: undefined,
        itemType: undefined,
        planningCode: undefined,
        description: undefined,
        centralizedPurchasingType: undefined,
        buyerName: undefined,
        deliveryType: undefined,
        categorySetId: undefined,
        categoryCodeId: undefined,
        buildInWipFlag: undefined,
        purchasingEnabledFlag: undefined
      }
      // this.handleQuery()
    },
    // 类别-下拉框
    getPullDownCodeList () {
      apiItemCategoryCodePullDownList({ organizationId: this.organizationCodeOrigin }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.categoryCodeIdList = list
        }
      })
    },
    // 类别集-下拉框
    getPullDownList () {
      apiItemCategorySetPullDownList({ organizationId: this.organizationCodeOrigin }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.categorySetIdList = list
        }
      })
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('mdm/itemAttribute/template', {
        ...this.queryParams
      }, `物料属性导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmItemOrganizationItem/export', {
      //   ...this.queryParams
      // }, `物料属性_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.itemcode{
  /deep/.ant-select{
    display: unset;
  }
  /deep/.ant-input-group.ant-input-group-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-code-select {
    // width: 48% !important;
    flex: 1;
  }
  .item-code-select-separator {
    margin: 0 5px;
  }
}
.page-header-content{
  /deep/.ant-select{
    width: 140px !important;
  }
  input{
    width: 140px;
  }
  /deep/.ant-input-number{
    width: 130px;
  }
}

</style>
